import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { FocusOn } from 'react-focus-on';
import styled from 'styled-components';

let iOS = false;
if(typeof navigator !== 'undefined') {
    iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !(window as any).MSStream;
}

const StyledBackdrop = styled.div`background-color: #000; position: fixed; top: 0; bottom: 0; left: 0; right: 0; opacity: 0.8; z-index: 99; width: 100vw; height: 100vh;`;
const StyledModal = styled.div`
    position: fixed; z-index: 999; margin: 0;
    display: flex; width: 100vw; height: 100${iOS ? '%' : 'vh'};
    flex-direction: column; top: 0; left: 0;
    align-items: center;

    & > div {
        display: flex;
        flex-direction: column;
        @media screen and (min-width: 767px) {
            padding: 2.5em;
        }
    }

    & .btn { background: transparent; margin: 0; padding: 0.25em 0.5em; border: 0; border-radius: 0.5em; cursor: pointer; }
    & .btn:hover { background-color: #eee; }
    & .body { background-color: #fff; overflow-y: auto; flex: 1; padding: 1em; width: 100%; border-radius: 0.5em; }
`;

interface Props {
    onClose?: () => void;
    bodyStyle?: React.CSSProperties;
    children?: React.ReactNode;
}
export const Alert: React.FC<Props> = (p) => {
    const { children, onClose, bodyStyle = {} } = p;

    function _handleClose(e: React.MouseEvent | React.TouchEvent | Event | MouseEvent | TouchEvent) {
        e.stopPropagation();
        onClose && onClose();
    }

    // Ref to hold the portal div
    const rootElemRef = React.useRef<HTMLElement>(undefined);
    if(!rootElemRef.current) {
        rootElemRef.current = document.createElement('aside');
    }

    // Hook to create add the portal div to the DOM
    React.useEffect(() => {
        const parentElem = document.body;
        // Add the detached element to the parent
        parentElem.appendChild(rootElemRef.current as Node);
        // This function is run on unmount
        return () => { rootElemRef.current?.remove(); };
    }, []);

    return ReactDOM.createPortal(<FocusOn onClickOutside={_handleClose} onEscapeKey={_handleClose} shards={[]}>
        <StyledBackdrop onClick={_handleClose} />
        <StyledModal>
            <div style={{}}>
                <div className="body" style={bodyStyle}>
                    <button className="btn fa fa-times" title="Close this window." onClick={_handleClose} style={{ float: 'right' }}></button>
                    {children}
                </div>
            </div>
        </StyledModal>
    </FocusOn>, rootElemRef.current);
};
